module.exports = __webpack_public_path__ + "static/media/Wilfredo Keng.50f14ff4.png";